import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=81ad5510"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports